import React, { useEffect, useRef } from 'react'
import logo from './logo.svg'
import './App.css'
import { Application, Texture, Sprite, Graphics, Container } from 'pixi.js'
import Victor from 'victor'

const ANT_VIEW_DISTANCE = 30
const START_ANTS = 10
const ANT_SIZE = 16
const WALK_SPEED = 1

function seperation (position: Victor, boids: Victor[]) {
  // Choose a distance at which boids start avoiding each other
  const desiredSeparation = ANT_VIEW_DISTANCE / 2

  const desired = new Victor(0,0)

  // For every flockmate, check if it's too close
  for (let i = 0, l = boids.length; i < l; ++i) {
    const other = boids[i]
    const dist = position.distance(other)
    if (dist < desiredSeparation && dist > 0) {
      // Calculate vector pointing away from the flockmate, weighted by distance
      const diff = position.clone().subtract(other).normalize().divideScalar(dist)
      desired.add(diff)
    }
  }
	
  // If the boid had flockmates to separate from
  if (desired.length() > 0) {
    // We set the average vector to the length of our desired speed
    desired.normalize().multiplyScalar(WALK_SPEED)

    // We then calculate the steering force needed to get to that desired velocity
    return desired
  }

  return desired
}



interface Ant {
  sprite: Sprite
  selectSprite: Graphics
  selected: boolean
  target: {x: number, y: number} | null
  speed: Victor
  group: Container
}

const app = new Application()

let time = 0
const NEST_OFF_X = 100
const NEST_OFF_Y = 100
const NEST_RADIUS = 20
const ants: Ant[][] = [
  [],
  []
]

function init() {
  console.log('init')
  const bg = new Graphics()
  bg.beginFill(0x009900)
  bg.drawRect(0,0,app.view.width, app.view.height)
  bg.endFill()

  bg.interactive = true
  bg.on('mousedown', (e) => {
    for (const ant of ants[0]) {
      if (ant.selected) {
        ant.target = {x: e.clientX, y: e.clientY}
      }
    }
  })

  app.stage.addChild(bg)
  for (let i = 0; i < 2; ++i) {
    const nest = new Graphics()
    nest.beginFill(i === 0 ? 0x0000FF : 0xFF0000, 0.8)
    nest.drawCircle(
      i === 0 ? NEST_OFF_X : app.view.width - NEST_OFF_X, 
      i === 0 ? NEST_OFF_Y : app.view.height - NEST_OFF_Y, 
      NEST_RADIUS
    )
    nest.endFill()
    app.stage.addChild(nest)
  }

  // starting ants
  for (let pIdx = 0; pIdx < 2; ++pIdx) {
    for (let i = 0; i < START_ANTS; ++i) {
      const antSprite = Sprite.from('ant.png')
        
      if (pIdx === 0) {
        antSprite.interactive = true
        antSprite.on('mousedown', () => {
          ants[pIdx][i].selected = !ants[pIdx][i].selected
          ants[pIdx][i].selectSprite.visible = ants[pIdx][i].selected
        })
      }
          
      const selectSprite = new Graphics()
      selectSprite.beginFill(0xFFFFFF, 1)
      selectSprite.drawCircle(0,0, ANT_SIZE / 2)
      selectSprite.endFill()
      selectSprite.visible = false
          
          
      const antGroup = new Container()
      antGroup.addChild(selectSprite)
      antGroup.addChild(antSprite)
      app.stage.addChild(antGroup)
          
      antSprite.anchor.set(0.5)
      antSprite.width = ANT_SIZE
      antSprite.height = ANT_SIZE
      antSprite.tint = pIdx === 0 ? 0x0000FF : 0xFF0000
      let x = pIdx === 0 ? NEST_OFF_X : app.view.width - NEST_OFF_X
      let y = pIdx === 0 ? NEST_OFF_X : app.view.height - NEST_OFF_Y
      x += NEST_RADIUS * 2 * Math.cos(i / START_ANTS * 2*Math.PI )
      y += NEST_RADIUS * 2 * Math.sin(i / START_ANTS * 2*Math.PI )
      antGroup.position.set(x, y)


      console.log(antGroup, pIdx, i)

      const ant:Ant = {
        sprite: antSprite, 
        selected: false, 
        selectSprite,
        target: null,
        group: antGroup,
        speed: null
      }

      ants[pIdx].push(ant)
    }
    
  }
  
}

function animate() {
  time += app.ticker.deltaMS

  for (const ant of ants[0]) {
    const otherAnts = ants[0].filter(a=>a!==ant)
    if (ant.target != null) {
      const position = new Victor(ant.group.x, ant.group.y)
      const sep = seperation(position, otherAnts.map(a => new Victor(a.group.x, a.group.y)))
      const goal = new Victor(ant.target.x, ant.target.y).subtract(position).normalize().multiplyScalar(WALK_SPEED)
      ant.speed = sep.add(goal).normalize().multiplyScalar(WALK_SPEED)
    }
    if (ant.speed != null) {
      ant.group.x += ant.speed.x
      ant.group.y += ant.speed.y
    }
  }
  
}

function App() {
  const loaded = useRef<boolean>(false)
  if (loaded.current) {
    console.log(loaded)
  }

  const ref = useRef<any>()
  useEffect(() => {
    if (ref.current != null) {
      ref.current.appendChild(app.view)
      app.start()
      
      
      init()
      app.ticker.add(animate)
      
      return () => {
        app.view.parentNode.removeChild(app.view)
        app.stop()
        app.destroy()
      }
    }
  }, [])


  return (
    <div className="App">
      <div ref={ref}></div>
    </div>
  )
}

export default App
